import Pile from "./Pile";

export default class CandyPile extends Pile {
    
    resetInitialCoords = () => {
        this.firstCardCoords = this.gameCtx.pilesContainer.getCandyPilePositions()
    }
}




